<section class="padding p-mt-3">
  <ds-panel [toggleable]="true" class="p-mb-4">
    <ds-panel-header>Zdarzenia w okresie subskrypcji</ds-panel-header>
    <ds-table
      [sterownik]="sterownik"
      [model]="tabelaAktualne"
      [columnTemplates]="{dataZdarzenia: dataZdarzenia}"
      [loading]="loadingAktualne">
    </ds-table>
  </ds-panel>

  <ds-panel [toggleable]="true" class="p-mb-4" *ngIf="pokazTabeleWczesniejsze">
    <ds-panel-header>
      Wcześniejsze zdarzenia
      <em class="pi pi-question-circle info-tooltip"
         [pTooltip]="'W tabeli prezentowane są zdarzenia, które miały miejsce od dnia udostępnienia usługi Newsletter (' + dataUdostepnienia + ')'">
      </em>
    </ds-panel-header>
    <ng-container>
      <ds-table
        [sterownik]="sterownikWczesniejsze"
        [model]="tabelaWczesniejsze"
        [columnTemplates]="{dataZdarzenia: dataZdarzenia}"
        [loading]="loadingWczesniejsze">
      </ds-table>
    </ng-container>
  </ds-panel>

</section>

<ng-template #dataZdarzenia let-row>
  <div class="ds-column-title">{{'dataZdarzenia' | transloco}}</div>
  <div class="ds-column-value">{{row.dataZdarzenia | date: formatDate}}</div>
</ng-template>
